import { Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { Item } from '../../utils/sharedTypes';
import CompaniesFilterBar from './CompaniesFilterBar';
import CompaniesOptionsBar from './CompaniesOptionsBar';
import CompaniesTable from './CompaniesTable';
import { CompanyFilter } from './companyTypes';

const initialFilters: CompanyFilter = {
  companyName: '',
};
const Companies = () => {
  const [selectedCompanies, setSelectedCompanies] = useState<Item[]>([]);
  const [filters, setFilters] = useState<CompanyFilter>(initialFilters);
  return (
    <>
      <CompaniesFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <Grid container alignItems='center' spacing={1}>
        <Grid item>
          <CompaniesOptionsBar
            selectedCompanies={selectedCompanies}
            setSelectedCompanies={setSelectedCompanies}
          />
        </Grid>
        <Grid item>
          <Typography variant='body2' align='center' color='textSecondary'>
            (Click a company's row for more information)
          </Typography>
        </Grid>
      </Grid>
      <CompaniesTable
        setSelectedCompanies={setSelectedCompanies}
        filters={filters}
      />
    </>
  );
};

export default Companies;
